import React, { useState, useEffect, useMemo } from 'react';
import Select from "react-select";
import { useTranslation } from "react-i18next";
import DataTable from 'react-data-table-component';
import axios from 'axios';
import moment from 'moment';
import bag from "../../Assets/Images/finance/bag.jpg";
import svgMoneyIncrease from "../../Assets/Images/finance/moneyIncrease.png";
import svgMoneyDecrease from "../../Assets/Images/finance/moneyDecrease.svg";
import svgDefault from "../../Assets/Images/finance/bag.jpg";
import { Row, Col } from 'reactstrap';
import CurrencyFormat from 'react-currency-format';
import { ToastContainer, toast } from 'react-toastify';
import CompDtCrmAccount from './CompDtCrmAccount';
import CompLoaderDt from '../Common/CompLoaderDt';

function CompDtCrmAccountStatement() {
    const { t } = useTranslation();
    const [componentId] = useState('compDtCashDesk');
    const [data, setData] = useState(null);
    const [accountId, setAccountId] = useState(null);
    const [startDate, setStartDate] = useState(moment(new Date(new Date().setMonth(new Date().getMonth() - 3))).format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment(new Date()).format('YYYY-MM-DD'));
    const [pageNumber, setPageNumber] = useState(0);
    const [pageSize, setPageSize] = useState(5);
    const [sort, setSort] = useState('transactionDate,DESC');
    const [paginationRowsPerPageOptions] = useState([1, 5, 10, 25, 50, 100]);
    const [totalRows, setTotalRows] = useState(0);

    const [seed, setSeed] = useState(null);
    const onChangeCompDtCrmAccount = (data) => {
        setSeed(data?.key);
        setAccountId(data?.accountId);
    }

    React.useEffect(() => {
        if (sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '') {
            if (accountId && accountId) {
                let currentSession = sessionStorage.getItem("currentSession");
                axios.defaults.headers.common["X-User-Language"] = t('language')?.toUpperCase();
                axios.defaults.headers.common["Authorization"] = currentSession !== null ? JSON.parse(currentSession)?.bearerToken : null;
                let ApiGateway = process.env.REACT_APP_API_URL;
                axios.get(ApiGateway + '/finance/account/account-statement/' + accountId + '/find-and-list?startDate=' + startDate + '&endDate=' + endDate + '&pageNumber=' + pageNumber + '&pageSize=' + pageSize + '&sort=' + sort)
                    .then(response => {
                        if (response.data?.isSucceed === true) {
                            setData(response.data?.payload);
                        }

                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
        }
    }, [t, seed, accountId, startDate, endDate, pageNumber, pageSize, sort]);

    const [deleteModal, setDeleteModal] = useState(false);
    const [recordId, setRecordId] = useState(false);

    const onGoToItemDetails = props => {
        //history.push('/product/' + props);
        //dispatch(mpMyCashDeskListApi(props));
    };

    const onBtnDeleteItem = props => {
        let message = 'Prohibited action!';
        toast.error(message, { autoClose: 1000 });
        console.log(props);
        setRecordId(props);
        //setDeleteModal(true);
    };

    const handleDeleteTask = () => {
        if (recordId) {
            //dispatch(mpMyCashDeskDeleteByIdApi({ cashDeskId: recordId }));
            //setDeleteModal(false);
            //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
            //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
        }
    };


    useEffect(() => {
        //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
    }, []);


    const handlePageChange = page => {
        setPageNumber(page - 1);
        //dispatch(mpMyCashDeskListApi(page - 1, pageSize, sort));
    }

    const handlePerRowsChange = async (newPerPage, page) => {
        setPageSize(newPerPage);
        //dispatch(mpMyCashDeskListApi(0, newPerPage, sort));
    }

    const columns = [
        {
            name: <span className='font-weight-bold fs-13'>{t('components.crm.crm-account-statement.comp-dt-crm-account-statement.dt.th.receipt-id')}</span>,
            selector: row =>
                <div className="d-flex align-items-center mt-2">
                    <div className="flex-shrink-0 mb-2">
                        <img src={bag} width={28} height={28} alt="" className="avatar-xs rounded-circle" />
                    </div>
                    <div className="flex-grow-1 ms-2">
                        <h6 className="mb-1">{/*<Link to={'/cash-desk/' + row.id + '/details'} className="text-body">{row.name}</Link>*/}{row.name}</h6>
                        <p className="text-muted mb-2">{row.receiptId}</p>
                    </div>
                    <div className="flex-shrink-0">
                    </div>
                </div>
            ,
            sortable: false,
            maxWidth: "220px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.crm.crm-account-statement.comp-dt-crm-account-statement.dt.th.title')}</span>,
            selector: row => row?.title,
            sortable: false,
            maxWidth: "300px"
        },
        {
            name: "",
            selector: row => {
                switch (row?.recordType?.value) {
                    case "CREDIT":
                        return <span><img src={svgMoneyIncrease} width={21} height={21} alt="" className="avatar-xxs me-2" /></span>;
                    case "DEBIT":
                        return <span><img src={svgMoneyDecrease} width={21} height={21} alt="" className="avatar-xxs me-2" /></span>;
                    default:
                        return <span><img src={svgDefault} width={21} height={21} alt="" className="avatar-xxs me-2" /></span>;
                }
            },
            sortable: false,
            maxWidth: "60px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.crm.crm-account-statement.comp-dt-crm-account-statement.dt.th.transaction-amount')}</span>,
            selector: row => <CurrencyFormat value={row?.amount} displayType={'text'} thousandSeparator={true} prefix={row?.currency?.symbol + ' '} />,
            sortable: false,
            maxWidth: "60px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.crm.crm-account-statement.comp-dt-crm-account-statement.dt.th.new-balance')}</span>,
            selector: row => <><span>{row?.currency?.symbol + ' '}</span><CurrencyFormat value={row?.balance} displayType={'text'} thousandSeparator={true} /></>,
            sortable: false,
            maxWidth: "60px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.crm.crm-account-statement.comp-dt-crm-account-statement.dt.th.transaction-date')}</span>,
            selector: row => row?.transactionDate != null ? moment(row?.transactionDate).format('DD.MM.YYYY HH:mm') : '-',
            sortable: false,
            maxWidth: "185px"
        },
    ];

    const [pending, setPending] = useState(true);
    const [rows, setRows] = useState([]);
    useEffect(() => {
        const timeout = setTimeout(() => {
            setRows(data?.content);
            setPending(false);
            setTotalRows(data?.page?.totalElements);
        }, 0);
        return () => clearTimeout(timeout);
    }, [data]);

    return (
        <React.Fragment>
            <ToastContainer />
            <Row>
                <Col className={"col-12"}>
                    <CompDtCrmAccount onChange={onChangeCompDtCrmAccount} />
                </Col>
            </Row>
            <Row className={accountId && accountId ? '' : 'd-none'}>
                <Col className={"col-12"}>
                    <br />
                    <hr />
                    <br />
                </Col>
            </Row>
            <Row className={accountId && accountId ? '' : 'd-none'}>
                <Col className={"col-12"}>
                    {data ? ((
                        <DataTable
                            id={componentId}
                            columns={columns}
                            data={rows}
                            pagination={true}
                            paginationServer
                            onPageChange={page => setPageNumber(page)}
                            paginationPerPage={pageSize}
                            paginationTotalRows={totalRows}
                            onChangePage={handlePageChange}
                            onChangeRowsPerPage={handlePerRowsChange}
                            progressPending={pending}
                            noDataComponent={t('data-table.label.no-data')}
                            paginationRowsPerPageOptions={paginationRowsPerPageOptions}
                            paginationComponentOptions={{
                                rowsPerPageText: t('data-table.label.rows-per-page'),
                                rangeSeparatorText: t('data-table.label.out-of'),
                            }}
                        />
                    )) : (
                        <Row>
                            <Col className={"col-md-12 text-center"}>
                                <CompLoaderDt />
                            </Col>
                        </Row>
                    )}
                </Col>
            </Row>
        </React.Fragment>
    );
}
export default CompDtCrmAccountStatement;